import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { throttle, fetchJson } from '@comeon/utility';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';

const TWO_MINUTES_IN_MS = 2 * 60 * 1000;

const useKeepAlive = () => {
	const isAuthenticated = useSelector(authenticationSelector);

	const throttledKeepAliveRef = useRef(
		throttle(() => {
			fetchJson('/player/status/keep-alive', undefined, { priority: 'low' });
		}, TWO_MINUTES_IN_MS)
	);

	const ping = useCallback(() => {
		if (throttledKeepAliveRef.current && isAuthenticated) {
			throttledKeepAliveRef.current();
		}
	}, [isAuthenticated, throttledKeepAliveRef]);

	return { ping };
};

export default useKeepAlive;
